/**
 * Access gate for the Person Workspace preview (merged contact + deal page).
 *
 * The workspace is a preview: visible to the allowlisted user(s) below plus
 * admins (SuperAdmin or CRM Admin) — invisible to everyone else even if this
 * code ships to production. Both the route guard (WorkspacePreviewRoute) and
 * the sidebar nav item use this single helper so the rules live in exactly
 * one place.
 */

const WORKSPACE_PREVIEW_EMAILS = ['mitchellm@future.loans'];
// Verified against Firestore users collection (mitchellm@future.loans)
const WORKSPACE_PREVIEW_UIDS = ['TmuusSn6mxaWmNUpPwgj1HjkPA13'];

export function isWorkspacePreviewUser(currentUser, superAdmin = false) {
  if (!currentUser) return false;
  const email = (currentUser.email || '').toLowerCase();
  return (
    WORKSPACE_PREVIEW_EMAILS.includes(email) ||
    WORKSPACE_PREVIEW_UIDS.includes(currentUser.uid) ||
    // Admins can see the preview — same CRM-admin definition the sidebar and
    // admin pages use (AuthContext merges CRMRole/SuperAdmin onto currentUser)
    superAdmin === true ||
    currentUser.SuperAdmin === true ||
    currentUser.CRMRole === 'CRM Admin'
  );
}
